import axiosInstance from '../api';

const unwrap = (r) => r.data;

export const getOverview = () => axiosInstance.get('/isms/overview').then(unwrap);

export const listRoles = () => axiosInstance.get('/isms/roles').then(unwrap);
export const assignRole = (body) => axiosInstance.put('/isms/roles', body).then(unwrap);
export const removeRole = (id) => axiosInstance.delete(`/isms/roles/${id}`);

export const getProfile = () => axiosInstance.get('/isms/profile').then(unwrap);
export const saveProfile = (body) => axiosInstance.put('/isms/profile', body).then(unwrap);

export const listRisks = () => axiosInstance.get('/isms/risks').then(unwrap);
export const createRisk = (body) => axiosInstance.post('/isms/risks', body).then(unwrap);
export const updateRisk = (id, body) => axiosInstance.put(`/isms/risks/${id}`, body).then(unwrap);
export const deleteRisk = (id) => axiosInstance.delete(`/isms/risks/${id}`);
export const generateRisks = () => axiosInstance.post('/isms/risks/generate').then(unwrap);
export const importRisks = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axiosInstance.post('/isms/risks/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(unwrap);
};
export const approveRisks = (summary) => axiosInstance.post('/isms/risks/approve', { summary }).then(unwrap);
export const listRiskVersions = () => axiosInstance.get('/isms/risks/versions').then(unwrap);

export const getSoa = () => axiosInstance.get('/isms/soa').then(unwrap);
export const saveSoaControl = (controlId, body) => axiosInstance.put(`/isms/soa/${controlId}`, body).then(unwrap);
export const approveSoa = (summary) => axiosInstance.post('/isms/soa/approve', { summary }).then(unwrap);
export const listSoaVersions = () => axiosInstance.get('/isms/soa/versions').then(unwrap);

export const listOrgUsers = () => axiosInstance.get('/users').then((r) => (Array.isArray(r.data) ? r.data : []));

// Authenticated download (the axios instance carries the auth header, so a plain <a href> would not work).
export const downloadFile = async (path, filename, mime) => {
  const r = await axiosInstance.get(path, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([r.data], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const userLabel = (u) => (u ? (u.userName || u.userEmail || u.user_email || u.email || `#${u.id}`) : '');
export const userEmailOf = (u) => (u ? (u.userEmail || u.user_email || u.email || '') : '');

export const errMsg = (e, fallback) => e?.response?.data?.message || e?.response?.data?.error || fallback;

// 5x5 scoring shared with the backend (score = likelihood x impact).
export const scoreOf = (l, i) => (l && i ? Number(l) * Number(i) : 0);
export const levelOf = (s) => (s <= 0 ? '' : s <= 4 ? 'LOW' : s <= 9 ? 'MEDIUM' : s <= 14 ? 'HIGH' : 'CRITICAL');
export const levelClass = (lvl) => ({ CRITICAL: 'aig-b-crit', HIGH: 'aig-b-high', MEDIUM: 'aig-b-med', LOW: 'aig-b-low' }[lvl] || 'aig-b-na');
